// biome-ignore lint/suspicious/noControlCharactersInRegex: stripping control characters is the point
const CONTROL_CHARACTERS = /[\u0000-\u001f\u007f-\u009f]/g;

export const sanitizeFreeText = (raw: string): string =>
  raw.replace(CONTROL_CHARACTERS, '').replace(/\s+/g, ' ').trim();
